import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import { config } from '@/config'

const axiosInstance = axios.create({
  baseURL: `${config.API_URL}`
})

// Para aumentar a segurança
axiosInstance.defaults.headers.common['Api-Key'] = config.API_KEY
// axiosInstance.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin'

Vue.use(VueAxios, axiosInstance)

export default axiosInstance

let token = localStorage.getItem('api_token')

const axiosAuth = axios.create({
  baseURL: `${config.API_URL}`
})

// Para aumentar a segurança
axiosAuth.defaults.headers.common['Authorization'] = `Bearer ${token}`
axiosAuth.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin'

Vue.use(VueAxios, axiosAuth)

export { axiosAuth }
